import type { FilterObject, PredefinedFilter } from 'app/filter.utils'

/**
 * The two hygiene recall lists. They share every rule except which side of
 * today the hygiene due date falls on:
 *
 * - `due-for-hygiene` — already overdue (hygieneDueDate in the past)
 * - `due-in-30-days`  — coming due inside the next 30 days
 *
 * Both windows are anchored to the current date at query time, so the lists
 * roll forward on their own.
 */
export const HYGIENE_OVERDUE_TAB = `due-for-hygiene`
export const HYGIENE_DUE_SOON_TAB = `due-in-30-days`

export type HygieneTab = typeof HYGIENE_OVERDUE_TAB | typeof HYGIENE_DUE_SOON_TAB

export function isHygieneTab(slug?: string): boolean {
  return slug === HYGIENE_OVERDUE_TAB || slug === HYGIENE_DUE_SOON_TAB
}

function hygieneDueDatePreset(tab: HygieneTab): string {
  return tab === HYGIENE_DUE_SOON_TAB ? `next_30_days` : `in_the_past`
}

/** Adult, active, unscheduled, non-perio patients whose recall lands in the tab's window. */
export function hygieneTabFilters(tab: HygieneTab): PredefinedFilter {
  return {
    patientStatus: { value: [`NonPatient`, `Inactive`, `Archived`], operator: `not_in` },
    [`appointmentStatus.keyword`]: { value: [`Scheduled`], operator: `not_in` },
    hygieneDueDate: { value: hygieneDueDatePreset(tab), operator: `between` },
    birthDate: { value: `18`, operator: `greater_equal_than` },
    isPerio: { value: [`false`], operator: `in` },
  }
}

/** The same rule set in the shape the sidebar count builder wants. */
export function hygieneTabFilterObjects(tab: HygieneTab): FilterObject[] {
  return Object.entries(hygieneTabFilters(tab)).map(([attribute, rule]) => ({
    attribute,
    ...rule,
  })) as FilterObject[]
}
